export const oauth2ProviderId = 'Google';

export const vanillaConstantName = 'OAuth2AuthorizationProxyGoogle';
